export const departmentContacts = [

  {
    departmentLabel: 'Service Department',
    email: 'lpservice@landpride.com',
    phone: '888-987-7433',
    extension: '1994',
    categoryId: '8104e9e3-9e51-480c-8d7c-576aa885656a',
  },

  {
    departmentLabel: 'Parts Department',
    email: 'lppart@landpride.com',
    phone: '888-987-7433',
    extension: '1992',
    categoryId: 'fe5672f8-a8f9-44f4-a592-9e00cc89d260',
  },

  {
    departmentLabel: 'Wholegoods Department',
    email: null,
    phone: '888-987-7433',
    extension: '1989',
    categoryId: '2f79b6d9-69d3-44ab-b659-18d1f3d6e8b6',
  },

  {
    departmentLabel: 'Credit Department',
    email: null,
    phone: '800-472-0166',
    extension: null,
    categoryId: 'e04ae47c-5233-44ab-ab11-4230b3a3373f',
  },

  {
    departmentLabel: 'Government/Fleet Contracts Department',
    email: null,
    phone: '888-987-7433',
    extension: '1220',
    categoryId: '9f1cefcd-2e8e-4872-a072-b64031be9e42',
  },

  {
    departmentLabel: 'Sales & Marketing Department',
    email: 'lpmedia@landpride.com',
    phone: '888-987-7433',
    extension: null,
    categoryId: 'd080c98b-1742-4067-926b-10194a39e829',
  },

  {
    departmentLabel: 'Warranty Department',
    email: 'lpwarranty@landpride.com',
    phone: '888-987-7433',
    extension: '1988',
    categoryId: '69fd55a3-17ca-431b-86ce-629d33186509',
  },

]